import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {ScheduleState, Service} from "@/lib/types/checks.ts";

interface CheckStatusChipProps {
  service: Service;
}

export const CheckStatusChip = ({service}: CheckStatusChipProps) => {
  let status: PillStatus;
  let secondStatus: PillStatus | null = null;

  if (!service.supports_downtime_alerting) {
    status = PillStatus.SILENCED;
  } else if (service.is_paused) {
    status = PillStatus.PAUSED;
  } else if (!service.cached_state_is_up) {
    status = PillStatus.DOWN;
  } else {
    status = PillStatus.UP;
  }

  if (service.is_under_maintenance) {
    secondStatus = PillStatus.MAINTENANCE;
  } else if (service.schedule_state === ScheduleState.SCHEDULED) {
    secondStatus = PillStatus.SCHEDULED_MAINTENANCE;
  }

  return (
    <div className="d-flex gap-2">
      <StatusPill type="checks" variant="textAndIcon" status={status} />
      {secondStatus && <StatusPill type="checks" variant="icon" status={secondStatus} />}
    </div>
  );
};
